
  
  import { runInjectionScript, swapDocument } from "@clerk/astro/internal";

  // Taken from https://github.com/withastro/astro/blob/e10b03e88c22592fbb42d7245b65c4f486ab736d/packages/astro/src/transitions/router.ts#L39.
  // Importing it directly from astro:transitions/client breaks custom client-side routing
  // even when View Transitions is disabled.
  const transitionEnabledOnThisPage = () => {
    return !!document.querySelector('[name="astro-view-transitions-enabled"]');
  }

  if (transitionEnabledOnThisPage()) {
    // We must do the dynamic imports within the event listeners because otherwise we may race and miss initial astro:page-load
    document.addEventListener('astro:before-swap', async (e) => {
      const { swapFunctions } = await import('astro:transitions/client');

      const clerkComponents = document.querySelector('#clerk-components');
      // Keep the div element added by Clerk
      if (clerkComponents) {
        const clonedEl = clerkComponents.cloneNode(true);
        e.newDocument.body.appendChild(clonedEl);
      }

      e.swap = () => swapDocument(swapFunctions, e.newDocument);
    });

    document.addEventListener('astro:page-load', async (e) => {
      const { navigate } = await import('astro:transitions/client');

      await runInjectionScript({
        ...{"signInUrl":"/auth/login","signUpUrl":"/auth/signup","localization":{"billing":{"checkout":{"perMonth":"one-time","description__subscriptionSuccessful":"Boarding pass secured. One payment, no renewals."}}},"sdkMetadata":{"version":"3.3.1","name":"@clerk/astro","environment":"production"}},
        routerPush: navigate,
        routerReplace: (url) => navigate(url, { history: 'replace' }),
      });
    })
  } else {
    await runInjectionScript({"signInUrl":"/auth/login","signUpUrl":"/auth/signup","localization":{"billing":{"checkout":{"perMonth":"one-time","description__subscriptionSuccessful":"Boarding pass secured. One payment, no renewals."}}},"sdkMetadata":{"version":"3.3.1","name":"@clerk/astro","environment":"production"}});
  }